import {ajaxPost,ajaxGet} from '../config/ajax.js';
import {loginUrl,loginout,getShtUserInfo, userLoginLog, queryNodeChangeLogList} from '../address/url.js';

// 登录接口
export const  login  = function(params) {
  return ajaxPost(loginUrl,params)
}
// get单点登录
export const GetShtUserInfo = function(params) {
  return ajaxGet(getShtUserInfo +'?'+ params)
}
export const  Loginout  = function(params) {
  return ajaxPost(loginout,params)
}
// 登录日志
export const  UserLoginLog  = function(params) {
  return ajaxPost(userLoginLog,params)
}
// 操作日志
export const  QueryNodeChangeLogList  = function(params) {
  return ajaxPost(queryNodeChangeLogList,params)
}


// WEBPACK FOOTER //
// ./src/js/login/ajax.js